import React, { Fragment } from "react";
import numeral from "numeral";
import Dropdown from "react-bootstrap/Dropdown";
import { QuotaItem } from "@rl-appliances/component-library";
import RlNavigationDropdownItem from "../header/navigation/components/RlNavigationDropdownItem";
import RlNavigationIcon from "../header/navigation/components/RlNavigationIcon";
import { RenderWhen } from "../../components";
import { Link } from "../../components/link";
import useQuotaUsage from "./hooks/useQuotaUsage";
import {
  IQuotaUsageDisplayData,
  IUsageItemResponse,
  IUsageItemTransformed,
  IUsageLimitGroup
} from "./@types/quotausage";
import { preventOnBeforeUnload, titleCase, isAdmin } from "../../utils";

const QuotaUsage = () => {
  const { enabled, usage, someExceeded } = useQuotaUsage();

  const transformUsageData = (
    usageDataLimitGroup: IUsageItemResponse[]
  ): IQuotaUsageDisplayData => {
    let limitType = "";
    const intervalData = usageDataLimitGroup.map(
      (usageDataItem: IUsageItemResponse): IUsageItemTransformed => {
        if (!limitType) limitType = usageDataItem.interval;
        return {
          exceeded: usageDataItem.quota_exceeded,
          label: usageDataItem.product,
          quota: numeral(usageDataItem.limit).format("0,0"),
          usage: usageDataItem.usage || "0",
          value: (usageDataItem.usage / usageDataItem.limit) * 100
        };
      }
    );
    const usageGroupLabel = `${titleCase(limitType)} Limits`;

    return { label: usageGroupLabel, data: intervalData };
  };

  const usageDisplayData = Object.values(usage)
    .filter((usageGroup: IUsageLimitGroup) => usageGroup.length > 0)
    .map((usageGroup: IUsageLimitGroup) => transformUsageData(usageGroup));

  return (
    <RenderWhen condition={enabled}>
      <RlNavigationDropdownItem
        title={
          someExceeded ? (
            <RlNavigationIcon name="pie-chart-danger" />
          ) : (
            <RlNavigationIcon name="pie-chart" />
          )
        }
        id="quota-usage"
        className="quota-usage"
      >
        {usageDisplayData.map((quotaItem: IQuotaUsageDisplayData, idx) => (
          <Fragment key={idx}>
            <QuotaItem
              attributes={[{ value: quotaItem.label }]}
              data={quotaItem.data}
              style={{}}
            />
            <Dropdown.Divider
              className="quota-usage__menu-item-separator"
              as="div"
            />
          </Fragment>
        ))}
        <div className="fs-sm">
          {isAdmin() && (
            <>
              <Link
                href={"/config/alerting"}
                variant="navigation"
                onClick={preventOnBeforeUnload}
              >
                Configure Quota Usage Alerts
              </Link>{" "}
              |{" "}
            </>
          )}
          <Link
            href="mailto:support@reversinglabs.com"
            variant="navigation"
            onClick={preventOnBeforeUnload}
          >
            Contact Customer Support
          </Link>
        </div>
      </RlNavigationDropdownItem>
    </RenderWhen>
  );
};

export default QuotaUsage;
